import { gql, useQuery } from '@apollo/client'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { AccessModules, CIE_PRODUCT, UserAccess } from './types'
import { UPSELL_ACCESS_QUERY } from 'query/query'
import { setIsUpsell } from 'reducers/user'
import { isInternal, useAuthentication } from '@ecosystem/newron-client-lib'

const endpoint = '/graphql'

const allMarketsAccessQueryString = `
query allMarketsAccessQuery {
  userModules {
    modules
    products
  }
}
`
// tslint:disable-next-line: variable-name
const All_MARKETS_ACCESS_QUERY = gql(allMarketsAccessQueryString)

export const useMarketAccessQuery = (): {
  modules: AccessModules[]
  products: string[]
  loading: boolean
} => {
  const { data, loading } = useQuery<{ userModules: UserAccess }>(All_MARKETS_ACCESS_QUERY, {
    context: { name: 'ECOSYSTEM' },
  })
  if (!data?.userModules?.modules) {
    return { modules: [], products: [], loading }
  }
  return {
    modules: data.userModules.modules as AccessModules[],
    products: data.userModules.products || [],
    loading,
  }
}

export const useUpsellAccess = (): {
  package_code: string[]
  loading: boolean
} => {
  const dispatch = useDispatch()
  const { data, loading } = useQuery<{ upsellAccess: { package_code: string[] } }>(
    UPSELL_ACCESS_QUERY
  )
  const { products } = useMarketAccessQuery()
  const { user } = useAuthentication()

  const isInternalUser = useMemo(() => (user ? isInternal(user) : false), [user])

  useEffect(() => {
    if (data?.upsellAccess?.package_code && products) {
      const isUpsell =
        data.upsellAccess.package_code.includes('consumer_upsell') &&
        !products?.includes(CIE_PRODUCT) &&
        !isInternalUser
      dispatch(setIsUpsell(isUpsell))
    }
  }, [data, dispatch, products, isInternalUser])

  if (!data?.upsellAccess?.package_code) {
    return { package_code: [], loading }
  }
  return {
    package_code: data.upsellAccess.package_code,
    loading,
  }
}

export const getAccessModules = async (token: string) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify([
      { query: allMarketsAccessQueryString, operationName: 'allMarketsAccessQuery' },
    ]),
  })

  const json = (await response.json())[0]
  const modules = json.data?.userModules?.modules || []
  const products = json.data?.userModules?.products || []
  return [...modules, ...products]
}
